import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=8d57d90a&scoped=true&"
import script from "./echart.vue?vue&type=script&lang=js&"
export * from "./echart.vue?vue&type=script&lang=js&"
import style0 from "./echart.vue?vue&type=style&index=0&id=8d57d90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d57d90a",
  null
  
)

export default component.exports